import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_PaymentCheckUpdateStatus, BASEURL_POLYMER } from '../../utils/api'
import { UpdatePaymentStatus } from '../../models/polymer/PaymentStatus.model'
interface QueryParams {
  application_uuid: string
  singpass_token: string

}
export const getPaymentCheckUpdateStatusApi = createApi({
  reducerPath: 'getPaymentCheckUpdateStatusApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER,
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "GET");
    headers.set("X-Content-Type-Options", "nosniff");
  }}),
  endpoints: (builder) => ({
    getPaymentCheckUpdateStatusApi: builder.query<UpdatePaymentStatus, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url:`${API_PaymentCheckUpdateStatus}?applicationUuid=${queryParams.application_uuid}`,
        headers: {
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      transformResponse:(response: UpdatePaymentStatus, meta, arg)=>{
        console.log('DEBUG: Raw API response for UpdatetPaymentStatusAPI:', response);
        return response;
      }
    }),
   
  }),
})

export const { useGetPaymentCheckUpdateStatusApiQuery } = getPaymentCheckUpdateStatusApi

